import React from 'react';
import { useNavigate } from 'react-router-dom';
import { StyleSheet, View } from './components/base_components';

import Breadcrumb from './components/breadcrumb';
import ProgressSpinner from './components/progress_spinner';
import StandardBoxList from './components/standard_box_list';
import CreditCard from './components/credit_card';

import OrgStore from './stores/org_store';
import PaymentMethodStore from './stores/payment_method_store';
import UserStore from './stores/user_store';

const styles = StyleSheet.create({
  orgPaymentAddScreen: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  spinner: {
    margin: '3rem',
    alignSelf: 'center',
  },
  creditCard: {
    marginTop: '0.5rem',
    marginLeft: '1rem',
    alignSelf: 'flex-start',
    width: '40rem',
  },
});

export default function OrgPaymentAddScreen() {
  const org_id = UserStore.useOrg()?.org_id;
  const org = OrgStore.useOrg(org_id);
  const navigate = useNavigate();

  React.useEffect(() => {
    OrgStore.fetch(org_id);
    PaymentMethodStore.fetch(org_id);
  }, [org_id]);

  function _onAddSuccess() {
    navigate(-1);
  }

  let content: any = null;
  if (!org) {
    content = <ProgressSpinner style={styles.spinner} color='#555' />;
  } else {
    content = (
      <>
        <Breadcrumb
          list={[
            { text: org?.org_name, url: `/org` },
            { text: 'Payment Methods', url: '/org/payment' },
            'Add Payment Method',
          ]}
        />
        <StandardBoxList title='Add Payment Method'>
          <CreditCard
            style={styles.creditCard}
            orgId={org.org_id}
            onSuccess={_onAddSuccess}
          />
        </StandardBoxList>
      </>
    );
  }
  return <View style={styles.orgPaymentAddScreen}>{content}</View>;
}
